export default {
    defaultLoadingMessage: 'Carregando...',
    rota: {
        origem: 'Inicial'
    },
    parametros: {}
}
